




















































import { Component, Watch } from 'vue-property-decorator';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import Transaction from '@/models/Accounts/Shared/Transactions/Transaction';
import DebitCreditCode from '@/models/Shared/DebitCreditCode';
import SingleAccountReportDialog from '@/components/Reporting/Reports/SingleAccountReportDialog.vue';
import InstitutionalAccountTransactionDetailsDialog from '@/components/Accounts/InstitutionAccounts/InstitutionalAccountTransactionDetailsDialog.vue';
import TransactionsOrderOptions from "@/models/Accounts/Shared/Transactions/TransactionsOrderOptions";
import ListUtils from '@/lib/listUtils';
import AccountType from '@/models/Shared/AccountType';
import { Debounce } from 'vue-debounce-decorator';

@Component({ name: 'InstitutionalAccount', components: { SingleAccountReportDialog, InstitutionalAccountTransactionDetailsDialog } })
export default class extends SaascadaVue {

    AccountType = AccountType;
    TransactionsOrderOptions = TransactionsOrderOptions;
    transactionsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.transactionsPage = +page;
        }
    }

    async beforeMount() {
        await InstitutionAccountModule.getInstitutionalTransactions({id: this.$route.params.id, page: this.transactionsPage});
    }

    @Watch('transactionsOrderSelection')
    async onTransactionsOrderSelectionChanged() {
        await InstitutionAccountModule.getInstitutionalTransactions({id: this.$route.params.id, page: this.transactionsPage});
    }

    @Watch('transactionsPage')
    async onTransactionsPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.transactionsPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.transactionsPage}` } });
        }
        // Get new transactions
        await InstitutionAccountModule.getInstitutionalTransactions({id: this.$route.params.id, page: this.transactionsPage});
    }

    get headers() {
        const isDisplayDate = this.transactionsOrderSelection === TransactionsOrderOptions.DisplayDate;
        const dateColumnHeader = isDisplayDate ? this.$t('pageText.institutionAccounts.fields.displayDate') : this.$t('pageText.institutionAccounts.fields.createdAt');

        return [
            { text: this.$t('pageText.institutionAccounts.fields.reference'), sortable: false, width: '20%' },
            { text: this.$t('pageText.institutionAccounts.fields.transactionType'), sortable: false, width: '15%' },
            { text: this.$t('pageText.institutionAccounts.fields.direction'), sortable: false, width: '10%' },
            { text: this.$t('pageText.institutionAccounts.fields.amount'), sortable: false, width: '10%' },
            { text: this.$t('pageText.institutionAccounts.fields.balanceAfter'), sortable: false, width: '15%' },
            { text: dateColumnHeader, sortable: false, width: '20%' },
            { text: this.$t('pageText.institutionAccounts.fields.moreInfo'), sortable: false, width: '10%' },
        ];
    }

    get account() {
        return InstitutionAccountModule.institutionalAccount;
    }

    get transactions() {
        return InstitutionAccountModule.institutionalTransactions;
    }

    get totalTransactionsPages() {
        return InstitutionAccountModule.totalInstitutionalAccountTransactionsPages;
    }

    get transactionsOrderOptions() {
        return ListUtils.transactionsOrderOptions();
    }

    get transactionsOrderSelection() {
        return InstitutionAccountModule.institutionalTransactionsOrder;
    }

    set transactionsOrderSelection(order: TransactionsOrderOptions) {
        InstitutionAccountModule.updateInstitutionalTransactionsOrder(order);
    }

    get pageSize() {
        return InstitutionAccountModule.pageSize;
    }

    get search() {
        return InstitutionAccountModule.institutionalTransactionsSearch;
    }

    set search(searchText: string) {
        InstitutionAccountModule.updateInstitutionalTransactionsSearch(searchText);
    }

    get loadingInstitutionalTransactions() {
        return InstitutionAccountModule.loadingInstitutionalTransactions;
    }

    getDebitCreditClass(code: DebitCreditCode) {
        if (code === DebitCreditCode.debit) {
            return "error--text";
        }
        else {
            return "success--text";
        }
    }

    // Wait before auto-searching to allow the user to type more
    @Debounce(500)
    @Watch("search", { immediate: false, deep: true })
    async searchChanged() {
        // Note that when the search changes it puts the user back to the first page, incase there are new transactions
        await InstitutionAccountModule.getInstitutionalTransactions({id: this.$route.params.id, page: 1});
    }

    // TODO: This is a workaround until the API returns the balance in an Amount object format
    formattedBalance(transaction: Transaction) {
        return {
            amount: transaction.balance,
            currency: transaction.amount.currency
        }
    }

}
